import { IOrderedItemView } from "interfaces/session/ShoppingCart";

function shoppingCartCount(items: IOrderedItemView[]) {
  return (items ? items
    .map((item: IOrderedItemView) => item.quantity)
    .reduce((total: number, cur: number) => total + cur, 0) : 0);
}

export default shoppingCartCount;
